(function() {
    'use strict';
    angular
        .module('telestatApp')
        .factory('DivisionConversionDynamicReport', DivisionConversionDynamicReport);

    DivisionConversionDynamicReport.$inject = ['$resource'];

    function DivisionConversionDynamicReport ($resource) {
        var resourceUrl =  'api/report/division-conversion-dynamic/:id';

        return $resource(resourceUrl, {}, {
            'query': { method: 'GET', isArray: true}
        });
    }
})();
